const unitOfMeasurementTypeEnum = Object.freeze({
    weight: 0,
    volume: 1,
})

export default unitOfMeasurementTypeEnum